// import { useState, useEffect } from "react";
// import { FaMoneyBillWave, FaUndo } from "react-icons/fa";
// import toast from "react-hot-toast";
// import salesService from "../../Services/salesService";

// const Income = () => {
//   const getCurrentDate = () => new Date().toISOString().split("T")[0];

//   const [totalSales, setTotalSales] = useState(0);
//   const [totalSalesReturn, setTotalSalesReturn] = useState(0);
//   const [startDate, setStartDate] = useState(getCurrentDate());
//   const [endDate, setEndDate] = useState(getCurrentDate());
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     fetchSalesData();
//     fetchSalesReturnData();
//   }, [startDate, endDate]);

//   const fetchSalesData = async () => {
//     try {
//       setLoading(true);
//       const response = await salesService.salesByDate({
//         start_date: startDate,
//         end_date: endDate,
//       });
//       setTotalSales(response?.[0]?.pharmacy_sale_Total || 0);
//     } catch (error) {
//       toast.error("Error fetching sales data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchSalesReturnData = async () => {
//     try {
//       setLoading(true);
//       const response = await salesService.salesReturnByDate({
//         start_date: startDate,
//         end_date: endDate,
//       });
//       setTotalSalesReturn(response?.[0]?.Return_Amount || 0);
//     } catch (error) {
//       toast.error("Error fetching sales return data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="p-4">
//       <h1 className="ml-[3%] text-[19px] text-gray-700 font-bold">Income</h1>
//       <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">Sales and Return Summary</h1>
//       <div className="flex mt-8 px-[3%]">
//         <div className="w-[25%] mb-4">
//         <p className="ml-2 text-sm font-bold">Start Date</p>
//           <input
//             type="date"
//             value={startDate}
//             onChange={(e) => setStartDate(e.target.value)}
//             className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1 w-full"
//           />
//         </div>
//         <div className="w-[25%] mb-4 ml-4">
//         <p className="ml-2 text-sm font-bold">End Date</p>
//           <input
//             type="date"
//             value={endDate}
//             onChange={(e) => setEndDate(e.target.value)}
//             className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1 w-full"
//           />
//         </div>
//       </div>
//       <div className="flex flex-wrap justify-between mx-[3%] mt-6 gap-4">
//         <div className="w-[48%] bg-green-100 p-6 rounded-xl shadow-md flex items-center justify-between">
//           <div>
//             <h2 className="text-gray-700 font-bold text-md">Total Sales</h2>
//             <p className="text-xl font-bold text-green-600">{loading ? "Loading..." : `PKR: ${totalSales}`}</p>
//           </div>
//           <FaMoneyBillWave className="text-green-500 text-4xl" />
//         </div>
//         <div className="w-[48%] bg-red-100 p-6 rounded-xl shadow-md flex items-center justify-between">
//           <div>
//             <h2 className="text-gray-700 font-bold text-md">Total Returns</h2>
//             <p className="text-xl font-bold text-red-600">{loading ? "Loading..." : `PKR: ${totalSalesReturn}`}</p>
//           </div>
//           <FaUndo className="text-red-500 text-3xl" />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Income;


import { useState, useEffect } from "react";
import { FaMoneyBillWave, FaUndo } from "react-icons/fa";
import { MdTrendingUp, MdTrendingDown, MdCalendarToday } from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import toast from "react-hot-toast";
import salesService from "../../Services/salesService";

const Income = () => {
  const getCurrentDate = () => new Date().toISOString().split("T")[0];

  const [totalSales, setTotalSales] = useState(0);
  const [totalSalesReturn, setTotalSalesReturn] = useState(0);
  const [startDate, setStartDate] = useState(getCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSalesData();
    fetchSalesReturnData();
  }, [startDate, endDate]);

  const fetchSalesData = async () => {
    try {
      setLoading(true);
      const response = await salesService.salesByDate({
        start_date: startDate,
        end_date: endDate,
      });
      setTotalSales(response?.[0]?.pharmacy_sale_Total || 0);
    } catch (error) {
      toast.error("Error fetching sales data.");
    } finally {
      setLoading(false);
    }
  };

  const fetchSalesReturnData = async () => {
    try {
      setLoading(true);
      const response = await salesService.salesReturnByDate({
        start_date: startDate,
        end_date: endDate,
      });
      setTotalSalesReturn(response?.[0]?.Return_Amount || 0);
    } catch (error) {
      toast.error("Error fetching sales return data.");
    } finally {
      setLoading(false);
    }
  };

  const netIncome = parseFloat(totalSales || 0) - parseFloat(totalSalesReturn || 0);

  const fmt = (val) =>
    parseFloat(val || 0).toLocaleString("en-PK", { minimumFractionDigits: 2 });

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap');
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .fade-up { animation: fadeUp 0.5s ease both; }
        .card-delay-1 { animation: fadeUp 0.5s ease 0.1s both; }
        .card-delay-2 { animation: fadeUp 0.5s ease 0.2s both; }
        .card-delay-3 { animation: fadeUp 0.5s ease 0.3s both; }
      `}</style>

      <div
        className="min-h-screen bg-[#f4f7fb] py-8 px-4"
        style={{ fontFamily: "'DM Sans', sans-serif" }}
      >
        <div className="max-w-[1400px] mx-auto">

          {/* ── Page Header ── */}
          <div className="mb-8 fade-up">
            <div className="flex items-center gap-3 mb-1">
              <div
                className="w-9 h-9 rounded-xl flex items-center justify-center"
                style={{ background: "linear-gradient(135deg, #00A95B, #007a40)" }}
              >
                <MdTrendingUp size={18} className="text-white" />
              </div>
              <h1
                className="text-[#0a2540] text-[26px]"
                style={{ fontFamily: "'DM Serif Display', serif" }}
              >
                Income
              </h1>
            </div>
            <p className="text-[#8a9bb0] text-sm ml-12">
              Sales and Return Summary
            </p>
          </div>

          {/* ── Date Filter Card ── */}
          <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] px-6 py-5 mb-6 fade-up">
            <div className="flex items-center gap-2 mb-4">
              <MdCalendarToday size={15} className="text-[#00A95B]" />
              <span className="text-[12px] font-semibold uppercase tracking-wider text-[#8a9bb0]">
                Date Range
              </span>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1">
                <label className="block text-[11px] font-semibold tracking-wider uppercase text-gray-500 mb-1.5">
                  Start Date
                </label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="w-full bg-[#f8fafc] border-[1.5px] border-[#dde4ed] rounded-xl px-4 py-2.5 text-[14px] text-[#0a2540] outline-none transition-all focus:border-[#00A95B] focus:ring-2 focus:ring-[#00A95B] focus:ring-opacity-20 focus:bg-white"
                />
              </div>
              <div className="flex-1">
                <label className="block text-[11px] font-semibold tracking-wider uppercase text-gray-500 mb-1.5">
                  End Date
                </label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="w-full bg-[#f8fafc] border-[1.5px] border-[#dde4ed] rounded-xl px-4 py-2.5 text-[14px] text-[#0a2540] outline-none transition-all focus:border-[#00A95B] focus:ring-2 focus:ring-[#00A95B] focus:ring-opacity-20 focus:bg-white"
                />
              </div>
            </div>
          </div>

          {/* ── Summary Cards ── */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">

            {/* Total Sales */}
            <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] p-6 card-delay-1">
              <div className="flex items-center justify-between mb-4">
                <span className="text-[11px] font-semibold uppercase tracking-wider text-[#8a9bb0]">
                  Total Sales
                </span>
                <div className="w-9 h-9 rounded-xl bg-[#f0fdf7] flex items-center justify-center">
                  <FaMoneyBillWave size={16} className="text-[#00A95B]" />
                </div>
              </div>
              {loading ? (
                <div className="flex items-center gap-2 text-[#8a9bb0]">
                  <AiOutlineLoading3Quarters size={16} className="animate-spin text-[#00A95B]" />
                  <span className="text-sm">Loading…</span>
                </div>
              ) : (
                <>
                  <p
                    className="text-[28px] font-bold text-[#0a2540] leading-tight"
                    style={{ fontFamily: "'DM Serif Display', serif" }}
                  >
                    {fmt(totalSales)}
                  </p>
                  <p className="text-[12px] text-[#8a9bb0] mt-1">PKR</p>
                </>
              )}
              <div className="mt-4 pt-4 border-t border-[#f0f4f8]">
                <span className="inline-flex items-center gap-1 text-[12px] font-medium text-[#00A95B]">
                  <MdTrendingUp size={14} />
                  Revenue earned
                </span>
              </div>
            </div>

            {/* Total Returns */}
            <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] p-6 card-delay-2">
              <div className="flex items-center justify-between mb-4">
                <span className="text-[11px] font-semibold uppercase tracking-wider text-[#8a9bb0]">
                  Total Returns
                </span>
                <div className="w-9 h-9 rounded-xl bg-[#fff5f5] flex items-center justify-center">
                  <FaUndo size={14} className="text-[#e55353]" />
                </div>
              </div>
              {loading ? (
                <div className="flex items-center gap-2 text-[#8a9bb0]">
                  <AiOutlineLoading3Quarters size={16} className="animate-spin text-[#00A95B]" />
                  <span className="text-sm">Loading…</span>
                </div>
              ) : (
                <>
                  <p
                    className="text-[28px] font-bold text-[#0a2540] leading-tight"
                    style={{ fontFamily: "'DM Serif Display', serif" }}
                  >
                    {fmt(totalSalesReturn)}
                  </p>
                  <p className="text-[12px] text-[#8a9bb0] mt-1">PKR</p>
                </>
              )}
              <div className="mt-4 pt-4 border-t border-[#f0f4f8]">
                <span className="inline-flex items-center gap-1 text-[12px] font-medium text-[#e55353]">
                  <MdTrendingDown size={14} />
                  Amount returned
                </span>
              </div>
            </div>

            {/* Net Income */}
            <div
              className="rounded-2xl p-6 card-delay-3"
              style={{
                background: "linear-gradient(135deg, #00A95B 0%, #007a40 100%)",
                boxShadow: "0 8px 24px rgba(0,169,91,0.25)",
              }}
            >
              <div className="flex items-center justify-between mb-4">
                <span className="text-[11px] font-semibold uppercase tracking-wider text-green-100">
                  Net Income
                </span>
                <div className="w-9 h-9 rounded-xl bg-white bg-opacity-20 flex items-center justify-center">
                  <MdTrendingUp size={16} className="text-white" />
                </div>
              </div>
              {loading ? (
                <div className="flex items-center gap-2 text-green-100">
                  <AiOutlineLoading3Quarters size={16} className="animate-spin text-white" />
                  <span className="text-sm">Loading…</span>
                </div>
              ) : (
                <>
                  <p
                    className="text-[28px] font-bold text-white leading-tight"
                    style={{ fontFamily: "'DM Serif Display', serif" }}
                  >
                    {fmt(netIncome)}
                  </p>
                  <p className="text-[12px] text-green-100 mt-1">PKR</p>
                </>
              )}
              <div className="mt-4 pt-4 border-t border-white border-opacity-20">
                <span className="text-[12px] font-medium text-green-100">
                  Sales − Returns
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Income;